module.exports = __webpack_public_path__ + "static/media/cp87.920bb5ab.jpg";